/**
 * /devhub/adobe — Adobe jobs (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubAdobeJobsPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubAdobeJobsPanel } from '../features/control-plane/DevHubAdobeJobsPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/adobe')({ component: AdobePage });

function AdobePage() {
  return (
    <DevHubPanelPage
      title="Adobe jobs"
      subtitle="Adobe generation jobs — status and evidence."
      status={{ label: 'live', live: true }}
    >
      <DevHubAdobeJobsPanel />
    </DevHubPanelPage>
  );
}
